// extracted by mini-css-extract-plugin
module.exports = {"title":"_404_title_3e8Go"};